import tryCall from '@v/util/tryCall.js'
import { Exception } from 'handlebars'

const saveImageCall = apiClient => async file => {
  if (!file) throw new Exception('Save image did not receive a file')
  const formData = new FormData()
  formData.append('image', file)
  const response = await apiClient.post(`//${window.location.host}/image`, formData, {
    headers: {
      accept: 'application/json',
      'Accept-Language': 'en-US,en;q=0.8',
      'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
    },
  })
  return response.data.url
}

export default class ImageService {
  constructor(vue) {
    this.vue = vue
  }

  saveImage(file) {
    return tryCall(
      async () => await saveImageCall(this.vue.$apiClient)(file),
      'Could not save image!',
    )
  }
}
